import React from 'react';
import { rest, _t } from 'utils';
import { getQueryTimeWindow, RecentRelativeTimeRange } from 'utils/time';
import { MONITORING_ALARM_EXPRESSION_METRIC, TITLE_MONITORING_ALARM_EXPRESSION_METRIC } from 'constant';
import MetricsGraph from './RefreshableGraph';

const metrics = [

  {
    metric: MONITORING_ALARM_EXPRESSION_METRIC.INSTANCE_CPU_UTILIZATION_AVERAGE,
    graphConfig: {
      max_y: 100,
      yax_units: '%',
      yax_units_append: true,
    },
  },
  {
    metric: MONITORING_ALARM_EXPRESSION_METRIC.INSTANCE_NETWORK_IN_BYTES,
    rate: '4m',
  },
  {
    metric: MONITORING_ALARM_EXPRESSION_METRIC.INSTANCE_NETWORK_OUT_BYTES,
    rate: '4m',
  },
  {
    metric: MONITORING_ALARM_EXPRESSION_METRIC.INSTANCE_NETWORK_IN_PACKETS,
    rate: '4m',
  },
  {
    metric: MONITORING_ALARM_EXPRESSION_METRIC.INSTANCE_NETWORK_OUT_PACKETS,
    rate: '4m',
  },
  {
    metric: MONITORING_ALARM_EXPRESSION_METRIC.INSTANCE_VOLUMES_READ_BYTES,
    rate: '4m',
  },
  {
    metric: MONITORING_ALARM_EXPRESSION_METRIC.INSTANCE_VOLUMES_WRITE_BYTES,
    rate: '4m',
  },
  {
    metric: MONITORING_ALARM_EXPRESSION_METRIC.INSTANCE_VOLUMES_READ_OPS,
    rate: '4m',
  },
  {
    metric: MONITORING_ALARM_EXPRESSION_METRIC.INSTANCE_VOLUMES_WRITE_OPS,
    rate: '4m',
  },

];

const getSelectorString = (obj) => {
  const arr = [];
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      arr.push(`${key}="${obj[key]}"`);
    }
  }

  return `{${arr.join(', ')}}`;
};

const maxDataPoints = 600;

const calcResolution = (timeWindow) => {
  const duration = timeWindow.duration / 1000;
  return Math.max(Math.floor(duration / maxDataPoints), 60); // Never higher than 1m
};

const getQueryObject = (metric, timeWindow, rate, uuid) => {
  const selector = { uuid };
  const selectorString = getSelectorString(selector);

  return {
    query: rate ? `irate(${metric}${selectorString}[${rate}])` : `${metric}${selectorString}`,
    start: timeWindow.start.toISOString(),
    end: timeWindow.end.toISOString(),
    step: calcResolution(timeWindow),
  };
};

const normalize = (rawData) => {
  rawData.data.result.forEach((result) => {
    result.values = result.values.map((dataPoint) => ({
      date: new Date(dataPoint[0] * 1000),
      value: parseFloat(dataPoint[1]),
    }));
  });
  return rawData;
};

const extractData = (rawData) => rawData.data.result.map((r) => r.values);

const createFetchAction = (metric, props) => (fetchParams) => {
  const timeRange = fetchParams.range || RecentRelativeTimeRange({ unit: 'hours', range: 2 });
  const timeWindow = getQueryTimeWindow(timeRange);
  const { uuid } = props;
  const queryObject = getQueryObject(metric.metric.toLowerCase(), timeWindow, metric.rate, uuid);
  const queryString = new URLSearchParams(queryObject).toString();

  return rest.get({ baseUrl: 'telemetry', url: `/query_range?${queryString}` }).then(normalize).then(extractData);
};

export default (uuid, eventBus) => {
  const graphConstructors = metrics.map((metric, index) => {
    const fetchAction = createFetchAction(metric, { uuid });
    const GraphComponent = MetricsGraph(fetchAction, eventBus);
    const params = metric.graphConfig || {};
    const prop = { ...params, title: _t(TITLE_MONITORING_ALARM_EXPRESSION_METRIC[metric.metric]) };

    return (props) => (<GraphComponent key={index} params={prop} {...props} />);
  });
  return (props) => {
    const graphs = graphConstructors.map((v) => v(props));
    return (
      <div className="graph-container">
        {graphs}
      </div>
    );
  };
};
